import { render, staticRenderFns } from "./WebIndex.vue?vue&type=template&id=148233bc&"
import script from "./WebIndex.vue?vue&type=script&lang=js&"
export * from "./WebIndex.vue?vue&type=script&lang=js&"
import style0 from "./WebIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports